import { generatePath } from 'react-router';

import { ContactItemDto } from '@/api/generated';
import { RouteEnum } from '@/models/route/Route.model.ts';
import { useAppNavigation } from '@/utils/useAppNavigation.util.ts';
import { ContactsTableRowCommon } from '@/views/contacts/components/table/components/ContactsTableRowCommon.comp.tsx';

type Props = {
  onCustomAction?: ((row: ContactItemDto) => Promise<void> | void) | undefined;
  row: ContactItemDto;
};

export const ContactsTableRow = ({ onCustomAction, row }: Props) => {
  const { push } = useAppNavigation();

  const detailsUrl = generatePath(RouteEnum.CONTACTS_DETAILS, {
    contactId: row.contactId.toString(),
  });

  const handleGoToCustomer = () => {
    push(detailsUrl);
  };

  return (
    <ContactsTableRowCommon
      detailsTo={detailsUrl}
      onCustomAction={onCustomAction}
      onRowClick={handleGoToCustomer}
      row={row}
    />
  );
};
